import { render } from "./certificateManagement.vue?vue&type=template&id=7adcb4d3"
import script from "./certificateManagement.vue?vue&type=script&lang=js"
export * from "./certificateManagement.vue?vue&type=script&lang=js"

import "./certificateManagement.vue?vue&type=style&index=0&id=7adcb4d3&lang=less"
script.render = render

export default script